var _circle, _rect, _path, _path2, _rect2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCreditWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.9999,
    r: 13.9355,
    fill: "url(#paint0_radial_3334_15229)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.5807,
    y: 2.06445,
    width: 26.8387,
    height: 26.8387,
    fill: "url(#paint1_radial_3334_15229)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.935 2.06445L125.58 29.1612H94.2912L109.935 2.06445Z",
    fill: "url(#paint2_radial_3334_15229)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88C40 85.7909 41.7909 84 44 84H55.0775C55.6629 84 56.2189 84.2565 56.5988 84.7018L62.4786 91.5921C63.2771 92.5278 64.7229 92.5278 65.5214 91.5921L71.4012 84.7018C71.7812 84.2565 72.3371 84 72.9225 84H84C86.2091 84 88 85.7909 88 88V128H40V88Z",
    fill: "url(#paint3_radial_3334_15229)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 48,
    width: 23,
    height: 27,
    rx: 10,
    fill: "url(#paint4_radial_3334_15229)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5 32V39.5H17V32.5H16V40V40.5H16.5H63.5V47V47.5H64.5V47V40.5H111.5H112V40V32.5H111V39.5H64.5V32H63.5Z",
    fill: "url(#paint5_linear_3334_15229)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3334_15229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2729 10.5617) rotate(134.754) scale(27.2819 24.7718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3334_15229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.0776 10.247) rotate(134.754) scale(26.2715 23.8543)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3334_15229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.855 10.3257) rotate(138.863) scale(28.6317 25.7623)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3334_15229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64 84) rotate(90) scale(45.6098 49.7561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3334_15229",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.8514 56.2317) rotate(130.184) scale(24.5665 21.9926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.55
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3334_15229",
    x1: 64,
    y1: 32,
    x2: 64,
    y2: 47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCreditWhite);
export default __webpack_public_path__ + "static/media/ic_credit_white.bc987daf7d058311a4fb110d5e0612e1.svg";
export { ForwardRef as ReactComponent };